export default "__VITE_PUBLIC_ASSET__2263efc0__"